import { createSlice } from "@reduxjs/toolkit";
import { CampaignRequirementSlice } from "types/campaign/requirement";
import { fetchCampaignRequirement } from "./thunk";

const initialState: CampaignRequirementSlice = {
    loading: false,
    error: null,
    items: {}
};


const campaignRequirements = createSlice({
    name: 'campaignRequirements',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(fetchCampaignRequirement.pending, (state) => {
            state.loading = true;
            state.error = null;
        })
        .addCase(fetchCampaignRequirement.fulfilled, (state, action) => {
            state.loading = false;
            state.error = null;
            state.items[action.payload.campaign.uuid] = {campaign_requirement: action.payload, last_fetched_at: Date.now()}
        })
        .addCase(fetchCampaignRequirement.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || "Failed to fetch campaign requirement"
        })
    }
})

export default campaignRequirements.reducer;